import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[scDropdownBtnItemTmp]',
    standalone: false
})
export class ScDropdownBtnItemDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
